export default "__VITE_ASSET__BbrTjFEC__"